export const states = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    slug: 'al',
    cities: [
      'Birmingham',
      'Montgomery',
      'Huntsville',
      'Mobile',
      'Tuscaloosa',
      'Hoover',
      'Dothan',
      'Auburn',
      'Decatur',
      'Madison',
      'Florence',
      'Gadsden',
      'Vestavia Hills',
      'Prattville',
      'Phenix City',
      'Alabaster',
      'Bessemer',
      'Enterprise',
      'Opelika',
      'Homewood',
      'Northport',
      'Anniston',
      'Prichard',
      'Athens',
      'Daphne',
      'Pelham',
      'Oxford',
      'Albertville',
      'Selma',
      'Troy',
      'Mountain Brook',
      'Trussville',
      'Helena',
      'Center Point',
      'Fairhope',
      'Ozark',
      'Alexander City',
      'Cullman',
      'Scottsboro',
      'Muscle Shoals',
      'Fort Payne',
      'Jasper',
      'Talladega',
      'Hueytown',
      'Gardendale',
    ],
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    slug: 'ak',
    cities: [
      'Anchorage',
      'Fairbanks',
      'Juneau',
      'Badger',
      'Knik-Fairview',
      'College',
      'Sitka',
      'Lakes',
      'Eagle River',
      'Chugiak',
      'Wasilla',
      'Palmer',
      'Kodiak',
      'Bethel',
      'Kenai',
      'Ketchikan',
      'Homer',
      'Soldotna',
      'Valdez',
      'Nome',
      'Barrow',
      'Seward',
      'Cordova',
      'Petersburg',
      'Wrangell',
      'Dillingham',
      'North Pole',
      'Unalaska',
      'Kotzebue',
      'Haines',
    ],
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    slug: 'az',
    cities: [
      'Phoenix',
      'Tucson',
      'Mesa',
      'Chandler',
      'Scottsdale',
      'Glendale',
      'Gilbert',
      'Tempe',
      'Peoria',
      'Surprise',
      'Yuma',
      'Avondale',
      'Goodyear',
      'Flagstaff',
      'Buckeye',
      'Lake Havasu City',
      'Casa Grande',
      'Maricopa',
      'Sierra Vista',
      'Prescott',
      'Bullhead City',
      'Prescott Valley',
      'Apache Junction',
      'Marana',
      'El Mirage',
      'Queen Creek',
      'Florence',
      'Kingman',
      'San Tan Valley',
      'Oro Valley',
      'Fountain Hills',
      'Nogales',
      'Douglas',
      'Eloy',
      'Coolidge',
      'Payson',
      'Sedona',
      'Cottonwood',
      'Camp Verde',
      'Show Low',
    ],
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    slug: 'ar',
    cities: [
      'Little Rock',
      'Fort Smith',
      'Fayetteville',
      'Springdale',
      'Jonesboro',
      'Rogers',
      'Conway',
      'North Little Rock',
      'Bentonville',
      'Pine Bluff',
      'Hot Springs',
      'Benton',
      'Texarkana',
      'Sherwood',
      'Jacksonville',
      'Russellville',
      'Bella Vista',
      'West Memphis',
      'Paragould',
      'Cabot',
      'Searcy',
      'Van Buren',
      'Bryant',
      'Maumelle',
      'Siloam Springs',
      'Harrison',
      'Blytheville',
      'Forrest City',
      'Mountain Home',
      'Marion',
      'Helena-West Helena',
      'Camden',
      'Magnolia',
      'Batesville',
      'Arkadelphia',
      'Malvern',
      'Stuttgart',
      'Clarksville',
      'Monticello',
      'Heber Springs',
    ],
  },
  {
    name: 'California',
    abbreviation: 'CA',
    slug: 'ca',
    cities: [
      'Los Angeles',
      'San Diego',
      'San Jose',
      'San Francisco',
      'Fresno',
      'Sacramento',
      'Long Beach',
      'Oakland',
      'Bakersfield',
      'Anaheim',
      'Santa Ana',
      'Riverside',
      'Stockton',
      'Irvine',
      'Chula Vista',
      'Fremont',
      'San Bernardino',
      'Modesto',
      'Moreno Valley',
      'Fontana',
      'Glendale',
      'Huntington Beach',
      'Santa Clarita',
      'Garden Grove',
      'Oceanside',
      'Rancho Cucamonga',
      'Ontario',
      'Santa Rosa',
      'Elk Grove',
      'Corona',
      'Lancaster',
      'Palmdale',
      'Salinas',
      'Pomona',
      'Hayward',
      'Escondido',
      'Sunnyvale',
      'Torrance',
      'Pasadena',
      'Orange',
      'Fullerton',
      'Thousand Oaks',
      'Roseville',
      'Concord',
      'Simi Valley',
      'Santa Clara',
      'Victorville',
      'Vallejo',
      'Berkeley',
      'El Monte',
      'Downey',
      'Costa Mesa',
      'Inglewood',
      'Carlsbad',
      'San Buenaventura',
      'Fairfield',
      'West Covina',
      'Murrieta',
      'Richmond',
      'Norwalk',
      'Antioch',
      'Temecula',
      'Burbank',
      'Daly City',
      'Rialto',
      'El Cajon',
      'San Mateo',
      'Clovis',
      'Compton',
      'Jurupa Valley',
      'Vista',
      'South Gate',
      'Mission Viejo',
      'Vacaville',
      'Carson',
      'Hesperia',
      'Santa Maria',
      'Redding',
      'Westminster',
      'Santa Monica',
      'Chico',
      'Newport Beach',
      'San Leandro',
      'San Marcos',
      'Whittier',
      'Hawthorne',
      'Citrus Heights',
      'Alhambra',
      'Tracy',
      'Livermore',
      'Buena Park',
      'Menifee',
      'Hemet',
      'Lakewood',
      'Merced',
      'Chino',
      'Indio',
      'Redwood City',
      'Lake Forest',
      'Napa',
    ],
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    slug: 'co',
    cities: [
      'Denver',
      'Colorado Springs',
      'Aurora',
      'Fort Collins',
      'Lakewood',
      'Thornton',
      'Arvada',
      'Westminster',
      'Pueblo',
      'Centennial',
      'Boulder',
      'Highlands Ranch',
      'Greeley',
      'Longmont',
      'Broomfield',
      'Castle Rock',
      'Commerce City',
      'Parker',
      'Littleton',
      'Northglenn',
      'Brighton',
      'Englewood',
      'Wheat Ridge',
      'Loveland',
      'Federal Heights',
      'Grand Junction',
      'Erie',
      'Ken Caryl',
      'Fountain',
      'Durango',
      'Steamboat Springs',
      'Golden',
      'Montrose',
      'Canon City',
      'Sterling',
      'Glenwood Springs',
      'Aspen',
      'Vail',
      'Telluride',
      'Trinidad',
    ],
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    slug: 'ct',
    cities: [
      'Bridgeport',
      'New Haven',
      'Stamford',
      'Hartford',
      'Waterbury',
      'Norwalk',
      'Danbury',
      'New Britain',
      'West Hartford',
      'Greenwich',
      'Fairfield',
      'Hamden',
      'Bristol',
      'Meriden',
      'Manchester',
      'West Haven',
      'Milford',
      'Stratford',
      'East Hartford',
      'Middletown',
      'Wallingford',
      'Enfield',
      'Southington',
      'Shelton',
      'Groton',
      'Norwich',
      'Trumbull',
      'Torrington',
      'Glastonbury',
      'Naugatuck',
      'Newington',
      'Vernon',
      'Cheshire',
      'Windsor',
      'Newtown',
      'Wethersfield',
      'South Windsor',
      'New London',
      'Guilford',
      'Branford',
    ],
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    slug: 'de',
    cities: [
      'Wilmington',
      'Dover',
      'Newark',
      'Middletown',
      'Smyrna',
      'Milford',
      'Seaford',
      'Georgetown',
      'Elsmere',
      'New Castle',
      'Millsboro',
      'Laurel',
      'Harrington',
      'Camden',
      'Clayton',
      'Lewes',
      'Milton',
      'Bridgeville',
      'Townsend',
      'Ocean View',
      'Selbyville',
      'Rehoboth Beach',
      'Bethany Beach',
      'Fenwick Island',
      'Delmar',
      'Wyoming',
      'Felton',
      'Greenwood',
      'Cheswold',
      'Dagsboro',
    ],
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    slug: 'fl',
    cities: [
      'Jacksonville',
      'Miami',
      'Tampa',
      'Orlando',
      'St. Petersburg',
      'Hialeah',
      'Port St. Lucie',
      'Cape Coral',
      'Tallahassee',
      'Fort Lauderdale',
      'Pembroke Pines',
      'Hollywood',
      'Miramar',
      'Gainesville',
      'Coral Springs',
      'Miami Gardens',
      'Clearwater',
      'Palm Bay',
      'Pompano Beach',
      'West Palm Beach',
      'Lakeland',
      'Davie',
      'Miami Beach',
      'Sunrise',
      'Boca Raton',
      'Deltona',
      'Plantation',
      'Large',
      'Deerfield Beach',
      'Palm Coast',
      'Melbourne',
      'Boynton Beach',
      'Lauderhill',
      'Weston',
      'Kissimmee',
      'Homestead',
      'Tamarac',
      'Delray Beach',
      'Daytona Beach',
      'North Miami',
      'Wellington',
      'North Port',
      'Jupiter',
      'Coconut Creek',
      'Port Orange',
      'Sanford',
      'Margate',
      'Ocala',
      'Sarasota',
      'Pensacola',
      'Bradenton',
      'Palm Beach Gardens',
      'Pinellas Park',
      'Coral Gables',
      'Doral',
      'Bonita Springs',
      'Apopka',
      'Oviedo',
      'Winter Garden',
      'Titusville',
      'Fort Myers',
      'Winter Haven',
      'Plant City',
      'Oakland Park',
      'Altamonte Springs',
      'Cutler Bay',
      'St. Cloud',
      'Aventura',
      'Ocoee',
      'Winter Springs',
      'Clermont',
      'Naples',
      'Estero',
      'Key West',
      'New Smyrna Beach',
    ],
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    slug: 'ga',
    cities: [
      'Atlanta',
      'Augusta',
      'Columbus',
      'Macon',
      'Savannah',
      'Athens',
      'Sandy Springs',
      'Roswell',
      'Johns Creek',
      'Albany',
      'Warner Robins',
      'Alpharetta',
      'Marietta',
      'Valdosta',
      'Smyrna',
      'Brookhaven',
      'Dunwoody',
      'Peachtree City',
      'Newnan',
      'Dalton',
      'Gainesville',
      'Milton',
      'Hinesville',
      'Statesboro',
      'Lawrenceville',
      'Woodstock',
      'Canton',
      'Kennesaw',
      'Douglasville',
      'Stockbridge',
      'LaGrange',
      'Carrollton',
      'McDonough',
      'Acworth',
      'Griffin',
      'Pooler',
      'Rome',
      'Peachtree Corners',
      'Sugar Hill',
      'Snellville',
      'Suwanee',
      'Duluth',
      'Covington',
      'Cartersville',
      'Evans',
    ],
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    slug: 'hi',
    cities: [
      'Honolulu',
      'East Honolulu',
      'Pearl City',
      'Hilo',
      'Kailua',
      'Waipahu',
      'Kaneohe',
      'Mililani Town',
      'Kahului',
      'Ewa Gentry',
      'Mililani Mauka',
      'Kihei',
      'Makakilo',
      'Wahiawa',
      'Schofield Barracks',
      'Wailuku',
      'Kapolei',
      'Ewa Beach',
      'Royal Kunia',
      'Halawa',
      'Waimalu',
      'Aiea',
      'Kailua-Kona',
      'Lahaina',
      'Waimea',
      'Kapaa',
      'Lihue',
      'Waianae',
      'Nanakuli',
      'Laie',
    ],
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    slug: 'id',
    cities: [
      'Boise',
      'Meridian',
      'Nampa',
      'Idaho Falls',
      'Pocatello',
      'Caldwell',
      "Coeur d'Alene",
      'Twin Falls',
      'Lewiston',
      'Post Falls',
      'Rexburg',
      'Eagle',
      'Moscow',
      'Kuna',
      'Ammon',
      'Chubbuck',
      'Mountain Home',
      'Jerome',
      'Blackfoot',
      'Garden City',
      'Burley',
      'Star',
      'Sandpoint',
      'Hailey',
      'Emmett',
      'Rupert',
      'Hayden',
      'Middleton',
      'Weiser',
      'Rathdrum',
    ],
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    slug: 'il',
    cities: [
      'Chicago',
      'Aurora',
      'Naperville',
      'Joliet',
      'Rockford',
      'Springfield',
      'Elgin',
      'Peoria',
      'Champaign',
      'Waukegan',
      'Cicero',
      'Bloomington',
      'Arlington Heights',
      'Evanston',
      'Decatur',
      'Schaumburg',
      'Bolingbrook',
      'Palatine',
      'Skokie',
      'Des Plaines',
      'Orland Park',
      'Tinley Park',
      'Oak Lawn',
      'Berwyn',
      'Mount Prospect',
      'Normal',
      'Wheaton',
      'Hoffman Estates',
      'Oak Park',
      'Downers Grove',
      'Elmhurst',
      'Glenview',
      'DeKalb',
      'Lombard',
      'Moline',
      'Buffalo Grove',
      'Bartlett',
      'Urbana',
      'Crystal Lake',
      'Quincy',
      'Streamwood',
      'Carol Stream',
      'Romeoville',
      'Plainfield',
      'Hanover Park',
    ],
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    slug: 'in',
    cities: [
      'Indianapolis',
      'Fort Wayne',
      'Evansville',
      'South Bend',
      'Carmel',
      'Fishers',
      'Bloomington',
      'Hammond',
      'Gary',
      'Lafayette',
      'Muncie',
      'Terre Haute',
      'Kokomo',
      'Noblesville',
      'Anderson',
      'Greenwood',
      'Elkhart',
      'Mishawaka',
      'Lawrence',
      'Jeffersonville',
      'Columbus',
      'Portage',
      'New Albany',
      'Richmond',
      'Westfield',
      'Valparaiso',
      'Goshen',
      'Michigan City',
      'Granger',
      'Merrillville',
      'Crown Point',
      'Plainfield',
      'Schererville',
      'Brownsburg',
      'Avon',
      'Zionsville',
      'Shelbyville',
      'Marion',
      'Munster',
      'Highland',
    ],
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    slug: 'ia',
    cities: [
      'Des Moines',
      'Cedar Rapids',
      'Davenport',
      'Sioux City',
      'Iowa City',
      'Waterloo',
      'Ames',
      'West Des Moines',
      'Council Bluffs',
      'Ankeny',
      'Dubuque',
      'Urbandale',
      'Cedar Falls',
      'Marion',
      'Bettendorf',
      'Mason City',
      'Marshalltown',
      'Clinton',
      'Burlington',
      'Ottumwa',
      'Fort Dodge',
      'Muscatine',
      'Coralville',
      'Johnston',
      'North Liberty',
      'Clive',
      'Newton',
      'Indianola',
      'Waukee',
      'Grinnell',
      'Altoona',
      'Norwalk',
      'Boone',
      'Spencer',
      'Storm Lake',
    ],
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    slug: 'ks',
    cities: [
      'Wichita',
      'Overland Park',
      'Kansas City',
      'Olathe',
      'Topeka',
      'Lawrence',
      'Shawnee',
      'Manhattan',
      'Lenexa',
      'Salina',
      'Hutchinson',
      'Leavenworth',
      'Leawood',
      'Dodge City',
      'Garden City',
      'Emporia',
      'Derby',
      'Prairie Village',
      'Junction City',
      'Hays',
      'Liberal',
      'Newton',
      'Pittsburg',
      'Great Bend',
      'McPherson',
      'El Dorado',
      'Ottawa',
      'Winfield',
      'Arkansas City',
      'Andover',
      'Lansing',
      'Merriam',
      'Haysville',
      'Atchison',
      'Parsons',
    ],
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    slug: 'ky',
    cities: [
      'Louisville',
      'Lexington',
      'Bowling Green',
      'Owensboro',
      'Covington',
      'Richmond',
      'Georgetown',
      'Florence',
      'Hopkinsville',
      'Nicholasville',
      'Elizabethtown',
      'Henderson',
      'Frankfort',
      'Jeffersontown',
      'Independence',
      'Paducah',
      'Radcliff',
      'Ashland',
      'Madisonville',
      'Murray',
      'Erlanger',
      'Winchester',
      'St. Matthews',
      'Danville',
      'Fort Thomas',
      'Shively',
      'Shelbyville',
      'Glasgow',
      'Berea',
      'Middlesboro',
      'Bardstown',
      'Morehead',
      'Campbellsville',
      'Somerset',
      'Corbin',
    ],
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    slug: 'la',
    cities: [
      'New Orleans',
      'Baton Rouge',
      'Shreveport',
      'Lafayette',
      'Lake Charles',
      'Bossier City',
      'Kenner',
      'Monroe',
      'Alexandria',
      'Houma',
      'New Iberia',
      'Slidell',
      'Central',
      'Ruston',
      'Sulphur',
      'Hammond',
      'Harvey',
      'Natchitoches',
      'Gretna',
      'Thibodaux',
      'Opelousas',
      'Zachary',
      'Pineville',
      'Mandeville',
      'Covington',
      'Crowley',
      'Minden',
      'West Monroe',
      'Abbeville',
      'Gonzales',
      'Denham Springs',
      'Prairieville',
      'Youngsville',
      'Broussard',
      'Carencro',
    ],
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    slug: 'me',
    cities: [
      'Portland',
      'Lewiston',
      'Bangor',
      'South Portland',
      'Auburn',
      'Biddeford',
      'Sanford',
      'Saco',
      'Westbrook',
      'Augusta',
      'Scarborough',
      'Gorham',
      'Windham',
      'Brunswick',
      'Waterville',
      'Kennebunk',
      'Falmouth',
      'Brewer',
      'Presque Isle',
      'Bath',
      'Caribou',
      'Ellsworth',
      'Old Town',
      'Rockland',
      'Belfast',
      'Kittery',
      'Topsham',
      'Freeport',
      'Yarmouth',
      'Cape Elizabeth',
    ],
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    slug: 'md',
    cities: [
      'Baltimore',
      'Columbia',
      'Germantown',
      'Waldorf',
      'Silver Spring',
      'Frederick',
      'Ellicott City',
      'Glen Burnie',
      'Gaithersburg',
      'Bethesda',
      'Dundalk',
      'Rockville',
      'Bowie',
      'Towson',
      'Aspen Hill',
      'Wheaton',
      'Bel Air',
      'Potomac',
      'Severn',
      'Odenton',
      'Catonsville',
      'Woodlawn',
      'Hagerstown',
      'Annapolis',
      'College Park',
      'Severna Park',
      'Salisbury',
      'Laurel',
      'Greenbelt',
      'Cumberland',
      'Owings Mills',
      'Pikesville',
      'Essex',
      'Randallstown',
      'Pasadena',
      'Elkridge',
      'Crofton',
      'Olney',
      'Cockeysville',
      'North Bethesda',
    ],
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    slug: 'ma',
    cities: [
      'Boston',
      'Worcester',
      'Springfield',
      'Cambridge',
      'Lowell',
      'Brockton',
      'New Bedford',
      'Quincy',
      'Lynn',
      'Fall River',
      'Newton',
      'Lawrence',
      'Somerville',
      'Framingham',
      'Haverhill',
      'Waltham',
      'Malden',
      'Brookline',
      'Plymouth',
      'Medford',
      'Taunton',
      'Chicopee',
      'Weymouth',
      'Revere',
      'Peabody',
      'Methuen',
      'Barnstable',
      'Pittsfield',
      'Attleboro',
      'Arlington',
      'Everett',
      'Salem',
      'Westfield',
      'Leominster',
      'Fitchburg',
      'Beverly',
      'Holyoke',
      'Marlborough',
      'Woburn',
      'Chelsea',
      'Amherst',
      'Northampton',
      'Natick',
      'Needham',
      'Wellesley',
    ],
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    slug: 'mi',
    cities: [
      'Detroit',
      'Grand Rapids',
      'Warren',
      'Sterling Heights',
      'Ann Arbor',
      'Lansing',
      'Flint',
      'Dearborn',
      'Livonia',
      'Clinton',
      'Canton',
      'Westland',
      'Troy',
      'Farmington Hills',
      'Kalamazoo',
      'Wyoming',
      'Southfield',
      'Rochester Hills',
      'Taylor',
      'Pontiac',
      'St. Clair Shores',
      'Royal Oak',
      'Novi',
      'Dearborn Heights',
      'Battle Creek',
      'Saginaw',
      'Kentwood',
      'East Lansing',
      'Roseville',
      'Portage',
      'Midland',
      'Lincoln Park',
      'Muskegon',
      'Holland',
      'Bay City',
      'Jackson',
      'Allen Park',
      'Wyandotte',
      'Traverse City',
      'Marquette',
      'Mount Pleasant',
      'Owosso',
      'Alpena',
      'Petoskey',
      'Cadillac',
    ],
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    slug: 'mn',
    cities: [
      'Minneapolis',
      'St. Paul',
      'Rochester',
      'Duluth',
      'Bloomington',
      'Brooklyn Park',
      'Plymouth',
      'St. Cloud',
      'Eagan',
      'Woodbury',
      'Maple Grove',
      'Eden Prairie',
      'Coon Rapids',
      'Burnsville',
      'Blaine',
      'Lakeville',
      'Minnetonka',
      'Apple Valley',
      'Edina',
      'St. Louis Park',
      'Mankato',
      'Moorhead',
      'Shakopee',
      'Maplewood',
      'Cottage Grove',
      'Richfield',
      'Roseville',
      'Inver Grove Heights',
      'Andover',
      'Brooklyn Center',
      'Savage',
      'Oakdale',
      'Fridley',
      'Winona',
      'Shoreview',
      'Ramsey',
      'Owatonna',
      'Chanhassen',
      'Prior Lake',
      'White Bear Lake',
    ],
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    slug: 'ms',
    cities: [
      'Jackson',
      'Gulfport',
      'Southaven',
      'Hattiesburg',
      'Biloxi',
      'Meridian',
      'Tupelo',
      'Greenville',
      'Olive Branch',
      'Horn Lake',
      'Clinton',
      'Pearl',
      'Ridgeland',
      'Starkville',
      'Columbus',
      'Vicksburg',
      'Pascagoula',
      'Ocean Springs',
      'Brandon',
      'Gautier',
      'Oxford',
      'Hernando',
      'Laurel',
      'Madison',
      'Natchez',
      'Corinth',
      'Clarksdale',
      'Moss Point',
      'McComb',
      'Grenada',
      'Brookhaven',
      'Cleveland',
      'Long Beach',
      'Picayune',
      'Bay St. Louis',
    ],
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    slug: 'mo',
    cities: [
      'Kansas City',
      'St. Louis',
      'Springfield',
      'Columbia',
      'Independence',
      "Lee's Summit",
      "O'Fallon",
      'St. Joseph',
      'St. Charles',
      'St. Peters',
      'Blue Springs',
      'Florissant',
      'Joplin',
      'Chesterfield',
      'Jefferson City',
      'Cape Girardeau',
      'Wildwood',
      'University City',
      'Ballwin',
      'Raytown',
      'Liberty',
      'Wentzville',
      'Mehlville',
      'Kirkwood',
      'Maryland Heights',
      'Hazelwood',
      'Gladstone',
      'Grandview',
      'Belton',
      'Webster Groves',
      'Sedalia',
      'Ferguson',
      'Arnold',
      'Affton',
      'Creve Coeur',
      'Nixa',
      'Ozark',
      'Republic',
      'Branson',
      'Rolla',
    ],
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    slug: 'mt',
    cities: [
      'Billings',
      'Missoula',
      'Great Falls',
      'Bozeman',
      'Butte',
      'Helena',
      'Kalispell',
      'Havre',
      'Anaconda',
      'Miles City',
      'Belgrade',
      'Livingston',
      'Laurel',
      'Whitefish',
      'Lewistown',
      'Sidney',
      'Glendive',
      'Columbia Falls',
      'Polson',
      'Hamilton',
      'Dillon',
      'Hardin',
      'Glasgow',
      'Deer Lodge',
      'Cut Bank',
      'Wolf Point',
      'Libby',
      'Red Lodge',
      'Conrad',
      'Shelby',
    ],
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    slug: 'ne',
    cities: [
      'Omaha',
      'Lincoln',
      'Bellevue',
      'Grand Island',
      'Kearney',
      'Fremont',
      'Hastings',
      'Norfolk',
      'North Platte',
      'Columbus',
      'Papillion',
      'La Vista',
      'Scottsbluff',
      'South Sioux City',
      'Beatrice',
      'Lexington',
      'Gering',
      'Alliance',
      'Blair',
      'York',
      'McCook',
      'Nebraska City',
      'Seward',
      'Crete',
      'Sidney',
      'Wayne',
      'Plattsmouth',
      'Ralston',
      'Schuyler',
      'Ogallala',
    ],
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    slug: 'nv',
    cities: [
      'Las Vegas',
      'Henderson',
      'Reno',
      'North Las Vegas',
      'Sparks',
      'Carson City',
      'Fernley',
      'Elko',
      'Mesquite',
      'Boulder City',
      'Fallon',
      'Winnemucca',
      'West Wendover',
      'Ely',
      'Yerington',
      'Pahrump',
      'Spring Creek',
      'Dayton',
      'Gardnerville',
      'Incline Village',
      'Minden',
      'Laughlin',
      'Summerlin',
      'Enterprise',
      'Whitney',
      'Sun Valley',
      'Spring Valley',
      'Sunrise Manor',
      'Paradise',
      'Winchester',
    ],
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    slug: 'nh',
    cities: [
      'Manchester',
      'Nashua',
      'Concord',
      'Dover',
      'Rochester',
      'Keene',
      'Derry',
      'Portsmouth',
      'Laconia',
      'Claremont',
      'Lebanon',
      'Londonderry',
      'Hudson',
      'Bedford',
      'Merrimack',
      'Goffstown',
      'Amherst',
      'Hampton',
      'Salem',
      'Milford',
      'Exeter',
      'Windham',
      'Hooksett',
      'Somersworth',
      'Durham',
      'Hanover',
      'Pelham',
      'Bow',
      'Barrington',
      'Gilford',
    ],
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    slug: 'nj',
    cities: [
      'Newark',
      'Jersey City',
      'Paterson',
      'Elizabeth',
      'Edison',
      'Woodbridge',
      'Lakewood',
      'Toms River',
      'Hamilton',
      'Trenton',
      'Clifton',
      'Camden',
      'Brick',
      'Cherry Hill',
      'Passaic',
      'Middletown',
      'Union City',
      'Old Bridge',
      'Gloucester',
      'East Orange',
      'Bayonne',
      'Franklin',
      'North Bergen',
      'Vineland',
      'Union',
      'Piscataway',
      'New Brunswick',
      'Jackson',
      'Wayne',
      'Irvington',
      'Parsippany-Troy Hills',
      'Hoboken',
      'Perth Amboy',
      'Plainfield',
      'Bloomfield',
      'East Brunswick',
      'Washington',
      'West New York',
      'South Brunswick',
      'Evesham',
      'Monroe',
      'Bridgewater',
      'Hackensack',
      'Sayreville',
      'Manchester',
    ],
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    slug: 'nm',
    cities: [
      'Albuquerque',
      'Las Cruces',
      'Rio Rancho',
      'Santa Fe',
      'Roswell',
      'Farmington',
      'Clovis',
      'Hobbs',
      'Alamogordo',
      'Carlsbad',
      'South Valley',
      'Gallup',
      'Deming',
      'Los Lunas',
      'Chaparral',
      'Sunland Park',
      'Las Vegas',
      'Portales',
      'Los Alamos',
      'Artesia',
      'Lovington',
      'Silver City',
      'Española',
      'Anthony',
      'Bernalillo',
      'North Valley',
      'Grants',
      'Socorro',
      'Ruidoso',
      'Taos',
    ],
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    slug: 'ny',
    cities: [
      'New York City',
      'Buffalo',
      'Yonkers',
      'Rochester',
      'Syracuse',
      'Albany',
      'New Rochelle',
      'Mount Vernon',
      'Schenectady',
      'Utica',
      'White Plains',
      'Hempstead',
      'Troy',
      'Niagara Falls',
      'Binghamton',
      'Freeport',
      'Valley Stream',
      'Long Beach',
      'Spring Valley',
      'Rome',
      'Ithaca',
      'Poughkeepsie',
      'North Tonawanda',
      'Jamestown',
      'Saratoga Springs',
      'Elmira',
      'Newburgh',
      'Middletown',
      'Auburn',
      'Lindenhurst',
      'Rockville Centre',
      'Ossining',
      'Garden City',
      'Watertown',
      'Kingston',
      'Plattsburgh',
      'Cortland',
      'Oneonta',
      'Glens Falls',
      'Beacon',
      'Peekskill',
      'Batavia',
      'Ogdensburg',
      'Geneva',
      'Canandaigua',
    ],
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    slug: 'nc',
    cities: [
      'Charlotte',
      'Raleigh',
      'Greensboro',
      'Durham',
      'Winston-Salem',
      'Fayetteville',
      'Cary',
      'Wilmington',
      'High Point',
      'Concord',
      'Greenville',
      'Asheville',
      'Gastonia',
      'Jacksonville',
      'Chapel Hill',
      'Huntersville',
      'Apex',
      'Burlington',
      'Kannapolis',
      'Monroe',
      'Mooresville',
      'Wake Forest',
      'Rocky Mount',
      'Holly Springs',
      'Indian Trail',
      'Cornelius',
      'Matthews',
      'Sanford',
      'Hickory',
      'Wilson',
      'Salisbury',
      'Fuquay-Varina',
      'New Bern',
      'Thomasville',
      'Leland',
      'Garner',
      'Carrboro',
      'Kernersville',
      'Mint Hill',
      'Morrisville',
      'Statesville',
      'Goldsboro',
      'Kinston',
      'Shelby',
      'Clemmons',
    ],
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    slug: 'nd',
    cities: [
      'Fargo',
      'Bismarck',
      'Grand Forks',
      'Minot',
      'West Fargo',
      'Williston',
      'Dickinson',
      'Mandan',
      'Jamestown',
      'Wahpeton',
      'Devils Lake',
      'Watford City',
      'Valley City',
      'Grafton',
      'Beulah',
      'Rugby',
      'Hazen',
      'Bottineau',
      'Lisbon',
      'Carrington',
      'Casselton',
      'Horace',
      'Lincoln',
      'Harvey',
      'Oakes',
    ],
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    slug: 'oh',
    cities: [
      'Columbus',
      'Cleveland',
      'Cincinnati',
      'Toledo',
      'Akron',
      'Dayton',
      'Parma',
      'Canton',
      'Youngstown',
      'Lorain',
      'Hamilton',
      'Springfield',
      'Kettering',
      'Elyria',
      'Lakewood',
      'Cuyahoga Falls',
      'Middletown',
      'Euclid',
      'Newark',
      'Mansfield',
      'Mentor',
      'Beavercreek',
      'Cleveland Heights',
      'Strongsville',
      'Dublin',
      'Fairfield',
      'Findlay',
      'Warren',
      'Lancaster',
      'Lima',
      'Huber Heights',
      'Westerville',
      'Marion',
      'Grove City',
      'Mason',
      'Reynoldsburg',
      'Delaware',
      'Brunswick',
      'Upper Arlington',
      'Stow',
      'Gahanna',
      'Hilliard',
      'Westlake',
      'Green',
      'Fairborn',
    ],
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    slug: 'ok',
    cities: [
      'Oklahoma City',
      'Tulsa',
      'Norman',
      'Broken Arrow',
      'Edmond',
      'Lawton',
      'Moore',
      'Midwest City',
      'Enid',
      'Stillwater',
      'Muskogee',
      'Bartlesville',
      'Owasso',
      'Shawnee',
      'Yukon',
      'Ardmore',
      'Ponca City',
      'Duncan',
      'Del City',
      'Bixby',
      'Sapulpa',
      'Altus',
      'Bethany',
      'Sand Springs',
      'Claremore',
      'Mustang',
      'Jenks',
      'El Reno',
      'Ada',
      'Durant',
      'Tahlequah',
      'Chickasha',
      'McAlester',
      'Glenpool',
      'Choctaw',
    ],
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    slug: 'or',
    cities: [
      'Portland',
      'Salem',
      'Eugene',
      'Gresham',
      'Hillsboro',
      'Beaverton',
      'Bend',
      'Medford',
      'Springfield',
      'Corvallis',
      'Albany',
      'Tigard',
      'Lake Oswego',
      'Keizer',
      'Grants Pass',
      'Oregon City',
      'McMinnville',
      'Redmond',
      'Tualatin',
      'West Linn',
      'Woodburn',
      'Forest Grove',
      'Newberg',
      'Wilsonville',
      'Roseburg',
      'Klamath Falls',
      'Ashland',
      'Milwaukie',
      'Sherwood',
      'Happy Valley',
      'Central Point',
      'Canby',
      'Hermiston',
      'Pendleton',
      'Coos Bay',
      'The Dalles',
      'Troutdale',
      'Silverton',
      'St. Helens',
      'Lebanon',
    ],
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    slug: 'pa',
    cities: [
      'Philadelphia',
      'Pittsburgh',
      'Allentown',
      'Erie',
      'Reading',
      'Scranton',
      'Bethlehem',
      'Lancaster',
      'Harrisburg',
      'Altoona',
      'York',
      'State College',
      'Wilkes-Barre',
      'Chester',
      'Easton',
      'Lebanon',
      'Hazleton',
      'New Castle',
      'Johnstown',
      'McKeesport',
      'Williamsport',
      'Norristown',
      'West Chester',
      'King of Prussia',
      'Pottstown',
      'Chambersburg',
      'Carlisle',
      'Hanover',
      'Gettysburg',
      'Mechanicsburg',
      'Doylestown',
      'Media',
      'Phoenixville',
      'Coatesville',
      'Lansdale',
      'Abington',
      'Bensalem',
      'Upper Darby',
      'Lower Merion',
      'Radnor',
      'Warminster',
      'Bristol',
      'Levittown',
      'Drexel Hill',
      'Monroeville',
    ],
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    slug: 'ri',
    cities: [
      'Providence',
      'Cranston',
      'Warwick',
      'Pawtucket',
      'East Providence',
      'Woonsocket',
      'Coventry',
      'Cumberland',
      'North Providence',
      'South Kingstown',
      'West Warwick',
      'Johnston',
      'North Kingstown',
      'Newport',
      'Bristol',
      'Westerly',
      'Smithfield',
      'Lincoln',
      'Central Falls',
      'Portsmouth',
      'Barrington',
      'Middletown',
      'Burrillville',
      'Narragansett',
      'Tiverton',
      'East Greenwich',
      'North Smithfield',
      'Warren',
      'Scituate',
      'Glocester',
    ],
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    slug: 'sc',
    cities: [
      'Charleston',
      'Columbia',
      'North Charleston',
      'Mount Pleasant',
      'Rock Hill',
      'Greenville',
      'Summerville',
      'Goose Creek',
      'Sumter',
      'Florence',
      'Hilton Head Island',
      'Spartanburg',
      'Myrtle Beach',
      'Aiken',
      'Anderson',
      'Mauldin',
      'Greer',
      'North Augusta',
      'Easley',
      'Simpsonville',
      'Hanahan',
      'Lexington',
      'Conway',
      'West Columbia',
      'North Myrtle Beach',
      'Clemson',
      'Irmo',
      'Fort Mill',
      'Bluffton',
      'Tega Cay',
      'Beaufort',
      'Port Royal',
      'Orangeburg',
      'Seneca',
      'Gaffney',
    ],
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    slug: 'sd',
    cities: [
      'Sioux Falls',
      'Rapid City',
      'Aberdeen',
      'Brookings',
      'Watertown',
      'Mitchell',
      'Yankton',
      'Pierre',
      'Huron',
      'Spearfish',
      'Vermillion',
      'Brandon',
      'Box Elder',
      'Madison',
      'Sturgis',
      'Belle Fourche',
      'Harrisburg',
      'Tea',
      'Dell Rapids',
      'Canton',
      'Hot Springs',
      'Lead',
      'Deadwood',
      'Mobridge',
      'Chamberlain',
    ],
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    slug: 'tn',
    cities: [
      'Nashville',
      'Memphis',
      'Knoxville',
      'Chattanooga',
      'Clarksville',
      'Murfreesboro',
      'Franklin',
      'Jackson',
      'Johnson City',
      'Bartlett',
      'Hendersonville',
      'Kingsport',
      'Collierville',
      'Smyrna',
      'Cleveland',
      'Brentwood',
      'Germantown',
      'Columbia',
      'La Vergne',
      'Spring Hill',
      'Gallatin',
      'Cookeville',
      'Lebanon',
      'Mount Juliet',
      'Morristown',
      'Oak Ridge',
      'Maryville',
      'Bristol',
      'Farragut',
      'Shelbyville',
      'Tullahoma',
      'Dyersburg',
      'Sevierville',
      'Dickson',
      'Greeneville',
      'Nolensville',
      "Thompson's Station",
      'Pigeon Forge',
      'Gatlinburg',
      'Crossville',
    ],
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    slug: 'tx',
    cities: [
      'Houston',
      'San Antonio',
      'Dallas',
      'Austin',
      'Fort Worth',
      'El Paso',
      'Arlington',
      'Corpus Christi',
      'Plano',
      'Laredo',
      'Lubbock',
      'Garland',
      'Irving',
      'Amarillo',
      'Grand Prairie',
      'Brownsville',
      'McKinney',
      'Frisco',
      'Pasadena',
      'Killeen',
      'McAllen',
      'Mesquite',
      'Midland',
      'Denton',
      'Waco',
      'Carrollton',
      'Round Rock',
      'Abilene',
      'Pearland',
      'Richardson',
      'Odessa',
      'Sugar Land',
      'Beaumont',
      'The Woodlands',
      'Lewisville',
      'Allen',
      'League City',
      'Tyler',
      'Edinburg',
      'Wichita Falls',
      'College Station',
      'San Marcos',
      'Conroe',
      'New Braunfels',
      'Flower Mound',
      'Temple',
      'Bryan',
      'Pharr',
      'Missouri City',
      'Baytown',
      'Cedar Park',
      'Pflugerville',
      'Georgetown',
      'Mansfield',
      'Rowlett',
      'North Richland Hills',
      'Burleson',
      'Victoria',
      'Wylie',
      'Cedar Hill',
      'Keller',
      'Rockwall',
      'Harlingen',
      'DeSoto',
      'Grapevine',
      'Coppell',
      'Haltom City',
      'Huntsville',
      'Lufkin',
      'Texarkana',
      'San Angelo',
      'Sherman',
      'Weatherford',
      'Cleburne',
      'Southlake',
    ],
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    slug: 'ut',
    cities: [
      'Salt Lake City',
      'West Valley City',
      'Provo',
      'West Jordan',
      'Orem',
      'Sandy',
      'Ogden',
      'St. George',
      'Washington',
      'Layton',
      'South Jordan',
      'Lehi',
      'Millcreek',
      'Taylorsville',
      'Logan',
      'Murray',
      'Draper',
      'Bountiful',
      'Riverton',
      'Herriman',
      'Spanish Fork',
      'Roy',
      'Pleasant Grove',
      'Kearns',
      'Tooele',
      'Cottonwood Heights',
      'Midvale',
      'Springville',
      'Eagle Mountain',
      'Cedar City',
      'Kaysville',
      'Clearfield',
      'Holladay',
      'American Fork',
      'Syracuse',
      'Saratoga Springs',
      'Magna',
      'Farmington',
      'Clinton',
      'North Ogden',
    ],
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    slug: 'vt',
    cities: [
      'Burlington',
      'South Burlington',
      'Rutland',
      'Barre',
      'Montpelier',
      'Winooski',
      'St. Albans',
      'Newport',
      'Vergennes',
      'Essex Junction',
      'Bennington',
      'Brattleboro',
      'Milton',
      'Hartford',
      'Williston',
      'Shelburne',
      'Colchester',
      'Middlebury',
      'St. Johnsbury',
      'Jericho',
      'Stowe',
      'Waterbury',
      'Morristown',
      'Swanton',
      'Lyndon',
    ],
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    slug: 'va',
    cities: [
      'Virginia Beach',
      'Chesapeake',
      'Norfolk',
      'Arlington',
      'Richmond',
      'Newport News',
      'Alexandria',
      'Hampton',
      'Roanoke',
      'Portsmouth',
      'Suffolk',
      'Lynchburg',
      'Centreville',
      'Dale City',
      'Reston',
      'Harrisonburg',
      'Leesburg',
      'Charlottesville',
      'Blacksburg',
      'Manassas',
      'Danville',
      'Ashburn',
      'Burke',
      'Mechanicsville',
      'Tuckahoe',
      'McLean',
      'Tysons',
      'Annandale',
      'Springfield',
      'Sterling',
      'Woodbridge',
      'Lake Ridge',
      'Gainesville',
      'Fairfax',
      'Herndon',
      'Chantilly',
      'Fredericksburg',
      'Winchester',
      'Salem',
      'Staunton',
      'Waynesboro',
      'Williamsburg',
      'Radford',
      'Bristol',
      'Colonial Heights',
    ],
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    slug: 'wa',
    cities: [
      'Seattle',
      'Spokane',
      'Tacoma',
      'Vancouver',
      'Bellevue',
      'Kent',
      'Everett',
      'Renton',
      'Yakima',
      'Federal Way',
      'Spokane Valley',
      'Kirkland',
      'Bellingham',
      'Kennewick',
      'Auburn',
      'Pasco',
      'Marysville',
      'Lakewood',
      'Redmond',
      'Shoreline',
      'Richland',
      'Sammamish',
      'Burien',
      'Olympia',
      'Lacey',
      'Edmonds',
      'Bremerton',
      'Puyallup',
      'Lynnwood',
      'Bothell',
      'Longview',
      'Issaquah',
      'Wenatchee',
      'Mount Vernon',
      'University Place',
      'Walla Walla',
      'Pullman',
      'Des Moines',
      'SeaTac',
      'Tumwater',
      'Oak Harbor',
      'Kenmore',
      'Ellensburg',
      'Moses Lake',
      'Camas',
    ],
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    slug: 'wv',
    cities: [
      'Charleston',
      'Huntington',
      'Morgantown',
      'Parkersburg',
      'Wheeling',
      'Weirton',
      'Fairmont',
      'Martinsburg',
      'Beckley',
      'Clarksburg',
      'South Charleston',
      'St. Albans',
      'Vienna',
      'Bluefield',
      'Elkins',
      'Nitro',
      'Dunbar',
      'Hurricane',
      'Princeton',
      'Bridgeport',
      'Cross Lanes',
      'Teays Valley',
      'Oak Hill',
      'Buckhannon',
      'Keyser',
      'Lewisburg',
      'Grafton',
      'Ravenswood',
      'Point Pleasant',
      'Ripley',
    ],
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    slug: 'wi',
    cities: [
      'Milwaukee',
      'Madison',
      'Green Bay',
      'Kenosha',
      'Racine',
      'Appleton',
      'Waukesha',
      'Eau Claire',
      'Oshkosh',
      'Janesville',
      'West Allis',
      'La Crosse',
      'Sheboygan',
      'Wauwatosa',
      'Fond du Lac',
      'New Berlin',
      'Wausau',
      'Brookfield',
      'Beloit',
      'Greenfield',
      'Fitchburg',
      'Mount Pleasant',
      'West Bend',
      'Sun Prairie',
      'Oak Creek',
      'Franklin',
      'Manitowoc',
      'Menomonee Falls',
      'Stevens Point',
      'Muskego',
      'Superior',
      'South Milwaukee',
      'De Pere',
      'Mequon',
      'Caledonia',
      'Germantown',
      'Middleton',
      'Onalaska',
      'Howard',
      'Ashwaubenon',
    ],
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    slug: 'wy',
    cities: [
      'Cheyenne',
      'Casper',
      'Laramie',
      'Gillette',
      'Rock Springs',
      'Sheridan',
      'Green River',
      'Evanston',
      'Riverton',
      'Jackson',
      'Cody',
      'Rawlins',
      'Lander',
      'Torrington',
      'Powell',
      'Douglas',
      'Worland',
      'Buffalo',
      'Wheatland',
      'Newcastle',
      'Thermopolis',
      'Lovell',
      'Afton',
      'Kemmerer',
      'Pinedale',
    ],
  },
]
